import {z} from 'zod';
import {FeatureConfigSchema} from '@packages/systems/feature-config/shared';

export const DashboardServerDataSchema = z.object({
  featureConfig: FeatureConfigSchema,
  sprigEnvironmentId: z.string().optional(),
  mailhogUrl: z.string().optional(),
});

export type DashboardServerData = z.infer<typeof DashboardServerDataSchema>;
